import { Record } from 'immutable'

export default Record({
  currentPage: null,
  perPage: null,
  totalItems: null,
  totalPages: null,
})
